<template>
	<div class="account-sidebar-nav">
		<nav class="account-page__nav">
			<template v-for="item in accountMenuItems" :key="item.key">
				<NuxtLink
					v-if="item.type === 'tab' || item.type === 'link'"
					:to="localePath(item.to || '/')"
					class="account-page__nav-item"
					:class="{ 'account-page__nav-item--active': item.type === 'tab' && isActive(item) }">
					<GlobalIcon :name="item.icon" :height="18" />
					{{ $t(`pages.account.sidebar.${item.translationKey}`) }}
				</NuxtLink>
				<a v-else :href="locale === 'pl' ? item.hrefPl : item.hrefEn" target="_blank" rel="noopener" class="account-page__nav-item">
					<GlobalIcon :name="item.icon" :height="18" />
					{{ $t(`pages.account.sidebar.${item.translationKey}`) }}
				</a>
			</template>
		</nav>

		<div class="account-page__logout">
			<v-divider></v-divider>
			<button type="button" class="account-page__nav-item account-page__nav-item--logout" @click="isLogoutConfirmOpen = true">
				<GlobalIcon name="logout2" :height="18" />
				{{ $t('pages.account.sidebar.logout') }}
			</button>
		</div>

		<ClientOnly>
			<GlobalModalGeneric
				v-if="isLogoutConfirmOpen"
				v-model="isLogoutConfirmOpen"
				genericTitle
				:text="$t('pages.account.logout_confirm_text')"
				:buttonAction="$t('pages.account.sidebar.logout')"
				@action="logout" />
		</ClientOnly>
	</div>
</template>

<script setup lang="ts">
import { accountMenuItems, type IAccountMenuItem } from '@/data/accountMenuData'

const { locale } = useI18n()
const localePath = useLocalePath()
const route = useRoute()
const router = useRouter()
const userStore = useUserStore()

const isActive = (item: IAccountMenuItem) => item.to === route.name?.toString().slice(0, -5)

const isLogoutConfirmOpen = ref(false)

const logout = async () => {
	await userStore.logout()
	router.push(localePath('/'))
}
</script>

<style lang="scss" scoped src="./SidebarNav.scss"></style>
